import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8ff8542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "adminMediaArchive" }
const _hoisted_2 = { id: "shovArchive" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--center" }
const _hoisted_6 = { class: "md1 flex ml-4" }
const _hoisted_7 = {
  class: "flex md3",
  style: {"display":"flex"}
}
const _hoisted_8 = { class: "flex md-3" }
const _hoisted_9 = { class: "flex md3" }
const _hoisted_10 = { class: "mediaArchiveContainer" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "fileName" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "ribbon-2"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "fileName" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "fileName" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "fileName" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "fileName" }
const _hoisted_23 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_25 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_26 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_28 = { class: "selectPageSize" }
const _hoisted_29 = { class: "center display-4" }
const _hoisted_30 = { class: "layout gutter--md" }
const _hoisted_31 = { class: "row justify--center" }
const _hoisted_32 = { class: "flex md9" }
const _hoisted_33 = { class: "flex md9" }
const _hoisted_34 = { class: "flex md9" }
const _hoisted_35 = { class: "flex md9" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Uploaded: ")
const _hoisted_37 = { class: "flex md9" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Sidst Redigeret: ")
const _hoisted_39 = { class: "flex md9" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Størrelse: ")
const _hoisted_41 = { class: "flex md9" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Type: ")
const _hoisted_43 = {
  key: 0,
  class: "flex md9 center"
}
const _hoisted_44 = ["src"]
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Afspil video ")
const _hoisted_46 = ["src"]
const _hoisted_47 = ["href"]
const _hoisted_48 = {
  key: 1,
  class: "flex md9 center mt-4 mb-4"
}
const _hoisted_49 = ["href"]
const _hoisted_50 = { class: "flex md9 mt-4" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Opdater")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6" }, "Er du sikker på at du vil slette filen", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6" }, "Handlingen kan ikke fortrydes", -1))
const _hoisted_56 = { class: "row justify--center" }
const _hoisted_57 = { class: "flex" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "row justify--center" }
const _hoisted_62 = { class: "flex" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "row justify--center" }
const _hoisted_66 = { class: "flex" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_68 = { class: "tabHeigh" }
const _hoisted_69 = { class: "uploadContainer" }
const _hoisted_70 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_it_drawer = _resolveComponent("it-drawer")!
  const _component_va_file_upload = _resolveComponent("va-file-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis mediefiler', 'Upload nye filer'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetSort()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.searchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findMediaFiles()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findMediaFiles()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.sortingValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sortingValue) = $event)),
              options: _ctx.sortingOption,
              label: "Sorter efter"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_va_icon, {
              name: _ctx.ascDesc ? 'arrow_drop_up' : 'arrow_drop_down',
              color: "success",
              gradient: "",
              size: "3rem",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ascDesc = !_ctx.ascDesc))
            }, null, 8, ["name"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.filterValue,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterValue) = $event)),
              options: _ctx.filterOptions,
              label: "Filtrer efter"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_it_divider),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaFiles, (file, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (file.mime.includes('image'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "mediaItem",
                    onClick: ($event: any) => (_ctx.editMediaFile(Number(file.id)))
                  }, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(file.name.slice(0,20) + (file.name.length > 20 ? '...' : '')), 1),
                    _createElementVNode("img", {
                      class: "cardImage",
                      src: _ctx.imageUrl + file.url
                    }, null, 8, _hoisted_13),
                    (file.name.startsWith('clublogo'))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Klublogo"))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_11))
                : (file.mime.includes('pdf'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "mediaItem",
                      onClick: ($event: any) => (_ctx.editMediaFile(Number(file.id)))
                    }, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(file.name.slice(0,20) + (file.name.length > 20 ? '...' : '')), 1),
                      _createVNode(_component_va_icon, {
                        class: "iconCard",
                        size: "5rem",
                        color: "info",
                        gradient: "",
                        name: "picture_as_pdf"
                      })
                    ], 8, _hoisted_15))
                  : (file.mime.includes('video'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "mediaItem",
                        onClick: ($event: any) => (_ctx.editMediaFile(Number(file.id)))
                      }, [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(file.name.slice(0,20) + (file.name.length > 20 ? '...' : '')), 1),
                        _createVNode(_component_va_icon, {
                          class: "iconCard",
                          size: "5rem",
                          color: "info",
                          gradient: "",
                          name: "videocam"
                        })
                      ], 8, _hoisted_17))
                    : (file.mime.includes('audio'))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "mediaItem",
                          onClick: ($event: any) => (_ctx.editMediaFile(Number(file.id)))
                        }, [
                          _createElementVNode("p", _hoisted_20, _toDisplayString(file.name.slice(0,20) + (file.name.length > 20 ? '...' : '')), 1),
                          _createVNode(_component_va_icon, {
                            class: "iconCard",
                            size: "5rem",
                            color: "info",
                            gradient: "",
                            name: "music_note"
                          })
                        ], 8, _hoisted_19))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 4,
                          class: "mediaItem",
                          onClick: ($event: any) => (_ctx.editMediaFile(Number(file.id)))
                        }, [
                          _createElementVNode("p", _hoisted_22, _toDisplayString(file.name.slice(0,20) + (file.name.length > 20 ? '...' : '')), 1),
                          _createVNode(_component_va_icon, {
                            class: "iconCard",
                            size: "5rem",
                            color: "info",
                            gradient: "",
                            name: "description"
                          })
                        ], 8, _hoisted_21))
            ], 64))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_24,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentPage) = $event)),
            type: "number",
            onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.jumpToPage(_ctx.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_25, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_26, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.jumpToPage(_ctx.totalNumberOfPages)))
          }),
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_it_drawer, {
          modelValue: _ctx.editMediaFileDrawer,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.editMediaFileDrawer) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.mediaFile.name), 1),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_va_input, {
                    class: "mediaInput",
                    modelValue: _ctx.mediaFile.name,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mediaFile.name) = $event)),
                    label: "Filnavn"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_va_input, {
                    class: "mediaInput",
                    modelValue: _ctx.mediaFile.alternativeText,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.mediaFile.alternativeText) = $event)),
                    label: "Alt-text"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_va_input, {
                    class: "mediaInput",
                    modelValue: _ctx.mediaFile.caption,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.mediaFile.caption) = $event)),
                    label: "Billedtekst"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("p", null, [
                    _hoisted_36,
                    _createElementVNode("i", null, _toDisplayString(_ctx.danishDate(_ctx.mediaFile.createdAt)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("p", null, [
                    _hoisted_38,
                    _createElementVNode("i", null, _toDisplayString(_ctx.danishDate(_ctx.mediaFile.updatedAt)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("p", null, [
                    _hoisted_40,
                    _createElementVNode("i", null, _toDisplayString(_ctx.mediaFile.size + ' kb'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("p", null, [
                    _hoisted_42,
                    _createElementVNode("i", null, _toDisplayString(_ctx.mediaFile.mime), 1)
                  ])
                ]),
                (_ctx.mediaFile.mime !== undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      (_ctx.mediaFile.mime.includes('image'))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "imgExample",
                            src: _ctx.imageUrl + _ctx.mediaFile.url,
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.seeFullSize(_ctx.mediaFile.url)))
                          }, null, 8, _hoisted_44))
                        : (_ctx.mediaFile.mime.includes('video'))
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              class: "clickAble",
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.playVideo(_ctx.mediaFile.url)))
                            }, [
                              _hoisted_45,
                              _createVNode(_component_va_icon, { name: "play_arrow" })
                            ]))
                          : (_ctx.mediaFile.mime.includes('audio'))
                            ? (_openBlock(), _createElementBlock("audio", {
                                key: 2,
                                src: _ctx.baseUrl + _ctx.mediaFile.url,
                                controls: ""
                              }, null, 8, _hoisted_46))
                            : (_ctx.mediaFile.mime.includes('pdf'))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 3,
                                  href: _ctx.baseUrl + _ctx.mediaFile.url,
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, "Læs pdf", 8, _hoisted_47))
                              : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mediaFile !== undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("a", {
                        href: _ctx.imageUrl + _ctx.mediaFile.url,
                        download: ""
                      }, "Download", 8, _hoisted_49)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_va_button_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_button, {
                        color: "success",
                        gradient: "",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateMediaFile(Number(_ctx.mediaFile.id))))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_51
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_va_button, {
                        color: "secondary",
                        gradient: "",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.editMediaFileDrawer = !_ctx.editMediaFileDrawer, _ctx.$Message.warning({ text: 'Annulleret' })))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_52
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_va_button, {
                        color: "danger",
                        gradient: "",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.deleteWarning()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_53
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createVNode(_component_va_modal, {
              modelValue: _ctx.deleteWarningModal,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.deleteWarningModal) = $event)),
              "hide-default-actions": "",
              blur: "",
              "no-dismiss": ""
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_va_button, {
                      class: "mr-2",
                      color: "danger",
                      gradient: "",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.deleteFile()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_58
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_button, {
                      class: "ml-2",
                      color: "secondary",
                      gradient: "",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.cancelDelete()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_59
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_54,
                _hoisted_55
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_modal, {
              modelValue: _ctx.fullSizeImgModal,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.fullSizeImgModal) = $event)),
              fullscreen: "",
              "hide-default-actions": ""
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createVNode(_component_va_button, {
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.fullSizeImgModal = !_ctx.fullSizeImgModal))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_63
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("img", { src: _ctx.urlModal }, null, 8, _hoisted_60)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_modal, {
              modelValue: _ctx.playVideoModal,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.playVideoModal) = $event)),
              "hide-default-actions": ""
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_va_button, {
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.playVideoModal = !_ctx.playVideoModal))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_67
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("video", {
                  src: _ctx.urlModal,
                  ref: "videoPlayer",
                  controls: ""
                }, null, 8, _hoisted_64)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis mediefiler']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createVNode(_component_va_file_upload, {
            dropzone: "",
            modelValue: _ctx.uploadFiles,
            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.uploadFiles) = $event)),
            "upload-button-text": "Upload fil",
            "drop-zone-text": "Træk filer hertil, eller"
          }, null, 8, ["modelValue"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadConfirmationText, (text, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "row justify--center"
          }, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("p", null, _toDisplayString(text), 1)
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.tabValue === 'Upload nye filer']
      ])
    ])
  ]))
}